// zone-flags.ts

// Adicionar eventos passivos para 'scroll' e 'touchstart'
(window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'touchstart'];

// Desabilitar patching para requestAnimationFrame
(window as any).__Zone_disable_requestAnimationFrame = true;

// Desabilitar patching para propriedades de eventos como onclick
(window as any).__Zone_disable_on_property = true;

// Desabilitar patching para eventos especificados
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove'];

// Para IE/Edge, habilitar verificação cross-context
(window as any).__Zone_enable_cross_context_check = true;
